import { format } from 'date-fns'

export const formatDifferentYears = (from: Date, to: Date, locale?: Locale) => {
  return `${format(from, 'dd MMM yyyy', { locale })} - ${format(to, 'dd MMM yyyy', { locale })}`
}

export const formatDifferentMonths = (from: Date, to: Date, locale?: Locale) => {
  return `${format(from, 'dd MMM', { locale })} - ${format(to, 'dd MMM', { locale })}`
}

export const formatSameMonthSingleDay = (from: Date, locale?: Locale) => {
  return `${format(from, 'dd MMM', { locale })}`
}

export const formatSameYearSingleDay = (from: Date, locale?: Locale) => {
  return `${format(from, 'dd MMM yyyy', { locale })}`
}

export const formatSameMonthMultipleDays = (from: Date, to: Date, locale?: Locale) => {
  return `${format(from, 'dd', { locale })} - ${format(to, 'dd MMM', { locale })}`
}

export const formatSameYear = (from: Date, to: Date, locale?: Locale) => {
  return `${format(from, 'dd MMM', { locale })} - ${format(to, 'dd MMM yyyy', { locale })}`
}
